import { ExternalNavCardButton, Icons } from '@vertex-protocol/web-ui';
import { BaseAppDialog } from 'client/modules/app/dialogs/BaseAppDialog';
import { useDialog } from 'client/modules/app/dialogs/hooks/useDialog';

export function HelpCenterDialog() {
  const { hide } = useDialog();

  const handleGetHelp = () => {
    hide();
    // Open the OpenWidget helpdesk popup
    const ow = (window as Record<string, unknown>).OpenWidget as
      | { call?: (method: string) => void }
      | undefined;
    if (ow?.call) {
      ow.call('maximize');
    }
  };

  return (
    <BaseAppDialog.Container onClose={hide}>
      <BaseAppDialog.Title onClose={hide}>Help Center</BaseAppDialog.Title>
      <BaseAppDialog.Body>
        <ExternalNavCardButton
          className="bg-surface-2"
          as="button"
          title="Get Help"
          description="Ask questions via our Helpdesk"
          icon={Icons.Question}
          onClick={handleGetHelp}
        />
      </BaseAppDialog.Body>
    </BaseAppDialog.Container>
  );
}
